import { name } from 'file-loader'
import * as types from './types'

// ----------------------------------
// PublicAF LIST ACTIONS
// ----------------------------------
export const updatePublicAFList = (value) => ({
    type: types.UPDATE_SEARCHLIST,
    payload: value
})

export const applyFilters = (searchModel) => ({
    type: types.APPLY_FILTERS,
    payload: searchModel
})

export const resetFilters = () => ({
    type: types.RESET_FILTERS,
    payload: ''
})

export const resetResults = () => ({
    type: types.RESET_RESULTS,
    payload: ''
})

export const changeFilterData = (payload) => ({
    type: types.CHG_FILTER_DATA,
    payload: payload
})

export const changeFilterPage = payload => ({
    type: types.CHG_FILTER_PAGE,
    payload: payload
})

export const changeFilterSort = payload => ({
    type: types.CHG_FILTER_SORT,
    payload: payload
})

export const changeFilterRowsPerPage = payload => ({
    type: types.CHG_FILTER_PAGE_SIZE,
    payload: payload
})

export const isLoading = (loading) => ({
    type: types.IS_LOADING,
    payload: loading
})

export const setConfirmationModal = (confirmModel) => ({
    type: types.SET_CONFIRM_MODAL,
    payload: confirmModel
})

export const hideConfirmationModal = () => ({
    type: types.HIDE_CONFIRM_MODAL,
    payload: ''
})

export const showConfirmationModal = () => ({
    type: types.SHOW_CONFIRM_MODAL,
    payload: ''
})

export const setListAlert = (payload) => ({
    type: types.SET_LIST_ALERT,
    payload: payload
})

export const hideListAlert = () => ({
    type: types.HIDE_LIST_ALERT,
    payload: ''
})

export const changeSelectedRows = (payload) => ({
    type: types.CHG_SELECTED_ROWS,
    payload: payload
})

export const updateListAlertData = (alertModel) => ({
    type: types.UPD_LIST_ALERT,
    payload: alertModel
})

//-------------------------------
// PublicAF ADD ACTIONS
//-------------------------------
export const resetAddData = () => ({
    type: types.RESET_ADD_DATA,
    payload: ''
})

export const showLoading = (loading) => ({
    type: types.INSERT_LOADING,
    payload: loading
})

export const changeAddData = (payload) => ({
    type: types.CHG_FIELD,
    payload: payload
})

export const changeAgeData = (payload) => ({
    type: types.CHG_AGE_DATA,
    payload: payload
})

export const setPublicAFAdd = (data) => ({
    type: types.SET_ADD_DATA,
    payload: data
})

export const updateAddAlertData = (alertModel) => ({
    type: types.UPD_ADD_ALERT,
    payload: alertModel
})

export const hideAddAlert = () => ({
    type: types.HIDE_ADD_ALERT,
    payload: ''
})

export const changeApplicantId = (payload) => ({
    type: types.CHG_APPLICANT_ID,
    payload: payload
})

export const showLegalDisclaimer = (disclaimerModal) => ({
    type: types.SHW_LEGAL_MODAL,
    payload: disclaimerModal
})

export const hideModal = () => ({
    type: types.HIDE_MODAL,
    payload: ''
})

export const showFileUploadModal = (fileUploadModal) => ({
    type: types.SHW_FILE_MODAL,
    payload: fileUploadModal
})

export const changeUploadFile = (payload) => ({
    type: types.CHG_FILE_UPLD,
    payload: payload
})

export const setAddEmailTemplate = (template) => ({
    type: types.SET_ADD_EMAIL_TEMPLATE,
    payload: template
})

// ----------------------------------
// PublicAF DETAIL ACTIONS
// ----------------------------------

export const hasDetailLoaded = (hasLoaded) => ({
    type: types.HAS_DETAIL_LOADED,
    payload: hasLoaded
})

export const updateDetailTitle = (title) => ({
    type: types.UPD_DETAIL_TITLE,
    payload: title
})

export const setDetailViewMode = (mode) => ({
    type: types.UPD_DETAIL_MODE,
    payload: mode
})

export const updateDetailData = (payload) => ({
    type: types.CHG_DETAIL_DATA,
    payload: payload
})

export const setDetailConfirmationModal = (confirmModel) => ({
    type: types.SET_DETAIL_CONFIRM_MODAL,
    payload: confirmModel
})

export const hideDetailConfirmationModal = () => ({
    type: types.HIDE_DETAIL_CONFIRM_MODAL,
    payload: ''
})

export const showDetailConfirmationModal = () => ({
    type: types.SHOW_DETAIL_CONFIRM_MODAL,
    payload: ''
})

export const setDetailAlert = (payload) => ({
    type: types.SET_DETAIL_ALERT,
    payload: payload
})

export const hideDetailAlert = () => ({
    type: types.HIDE_DETAIL_ALERT,
    payload: ''
})

export const setPublicAFDetail = (data, mode) => ({
    type: types.SET_DETAIL_DATA,
    payload: data,
    mode: mode
})

export const setAttachmentData = (data) => ({
    type: types.SET_ATTACHMENT_DATA,
    payload: data
})

export const showUpdateFileUploadModal = (fileUploadModal) => ({
    type: types.SHW_MODAL_FILE,
    payload: fileUploadModal
})

export const hideUpdateFileUploadModal = () => ({
    type: types.HIDE_MODAL_FILE,
    payload: ''
})

export const setDetailEmailTemplate = (template) => ({
    type: types.SET_DETAIL_EMAIL_TEMPLATE,
    payload: template
})